import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory('@@TAP/country');
export const getCountries = actionCreator.async('GET_COUNTRIES');
export const getBillableCountries = actionCreator.async('GET_BILLABLE_COUNTRIES');
//# sourceMappingURL=country.actions.js.map